import { render, staticRenderFns } from "./FaqTagsModal.vue?vue&type=template&id=6778e553&scoped=true"
import script from "./FaqTagsModal.vue?vue&type=script&lang=js"
export * from "./FaqTagsModal.vue?vue&type=script&lang=js"
import style0 from "./FaqTagsModal.vue?vue&type=style&index=0&id=6778e553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778e553",
  null
  
)

export default component.exports